import { PhysicalThingWithHp, STD_BASE_HP } from "../physicalThingWithHp";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class MossGate extends PhysicalThingWithHp {
	static key = "MossGate";
	constructor(xy: XY) {
		super(xy, false);
		this.hp = STD_BASE_HP;
		this.maxHp = STD_BASE_HP;
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	static deserialize(data: any): MossGate {
		const m = new MossGate(deserializeXY(data.xy));
		m.restoreBaseFields(data);
		return m;
	}
}
